import { Component, computed, Input, OnInit, signal } from '@angular/core';
import { FormControl } from '@angular/forms';
import { getClaimKey } from '../../../../functions/get-claim-key';
import { ClaimKey } from '../../../../models/api/core/claim-key';
import { FinancialOverviewResponse } from '../../../../models/api/view/claim/financials/financial-overview/financial-overview-response';
import { BaseComponent } from '../../../base/base.component';
import { CardComponent } from '../../../core/panels/card.component';
import {
  LoadingPanelComponent,
  LoadingState,
} from '../../../core/panels/loading-panel.component';
import { ColumnComponent } from '../../../core/table/column.component';
import { TableComponent } from '../../../core/table/table.component';

@Component({
  selector: 'app-overview-reimbursables-tab',
  imports: [
    CardComponent,
    TableComponent,
    ColumnComponent,
    LoadingPanelComponent,
  ],
  template: `
    <app-loading-panel [state]="loadingState" loadingStyle="Box">
      <ng-template #loaded>
        <div class="tw-flex tw-gap-4">
          <div class="tw-basis-full tw-min-w-0">
            <app-card label="Reimbursables">
              <app-table
                [dataSource]="activeReimbursables()"
                [pageSize]="10"
                [scrollable]="true"
                dataKey="description"
                recordLabel="reimbursable"
                [sortField]="'description'"
                [sortOrder]="1"
              >
                <app-column name="description" label="Description" />
                <app-column name="amount" label="Amount*" format="c" />
                <app-column name="recovered" label="Recovered" format="c" />
                <app-column name="outstanding" label="Outstanding" format="c" />
              </app-table>
              * Includes paid and scheduled
            </app-card>
          </div>
        </div>
      </ng-template>
    </app-loading-panel>
  `,
  styles: ``,
})
export class ReimbursablesTabComponent extends BaseComponent implements OnInit {
  @Input() level = new FormControl<string>('claim');

  loadingState: LoadingState = 'Loading';

  private _selectedLevel = signal<string>('claim');
  private _financialData = signal<FinancialOverviewResponse | null>(null);

  activeReimbursables = computed(() => {
    const data = this._financialData();
    const currentLevel = this._selectedLevel();

    if (!data) return [];

    switch (currentLevel) {
      case 'claim':
        return data.reimbursablesClaimLevel || [];
      case 'Claimant':
        return data.reimbursablesClaimantLevel || [];
      case 'Event':
        return data.reimbursablesEventLevel || [];
      default:
        return data.reimbursablesClaimLevel || [];
    }
  });

  async ngOnInit() {
    const claimKey: ClaimKey = getClaimKey();
    this._selectedLevel.set(this.level.value || 'claim');
    this.dispose.subs = this.level.valueChanges.subscribe((value) => {
      if (value) {
        this._selectedLevel.set(value);
      }
    });
    const response =
      await this.api.financialOverview.getPaymentSummary(claimKey);
    this._financialData.set(response);
    this.loadingState = 'Loaded';
  }
}
